import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { BdExportAsFileData } from '@bindoc-projects/util-domain-lib';
import { BD_UI_SIDE_SHEET_CONFIG_DEFAULT } from '@bindoc-projects/ui-lib/dialog/ui';
import { BdExportAsFileConfig } from './export.config';
import { BdExportAsFileInput } from './export-input';
import {
  BdExportAsFileDialogComponent,
  BdExportAsFileDialogData,
} from './dialog/dialog.component';

export interface BdExportAsFileDialogOptions {
  data: BdExportAsFileData;
  filename: string | null;
  config: BdExportAsFileConfig;
  authenticated: boolean;
}

/**
 * Opens the export-as-file side sheet. Shared by every export trigger
 * (`bd-export-as-file` button, `bd-chart-export-menu` item) so the dialog
 * behaves identically regardless of which UI initiated the export.
 *
 * Returns the dialog ref so a caller can react to the terminal
 * `BdExportAsFileDialogResult` on `onClose` — `bd-export-as-file` uses it to
 * raise the success/error toast. Callers that need no feedback ignore it.
 */
export function openBdExportAsFileDialog(
  dialogService: DialogService,
  options: BdExportAsFileDialogOptions,
): DynamicDialogRef {
  const input: BdExportAsFileInput = {
    filename: options.filename,
    data: options.data,
    labels: null,
    exportType: 'xlsx',
    saveInDownloadCenter: false,
  };

  const dialogConfig: DynamicDialogConfig<BdExportAsFileDialogData> = {
    ...BD_UI_SIDE_SHEET_CONFIG_DEFAULT,
    header: 'Export',
    data: {
      input,
      config: options.config,
      authenticated: options.authenticated,
    },
  };

  return dialogService.open(BdExportAsFileDialogComponent, dialogConfig);
}
